module.exports = __webpack_public_path__ + "img/HXXX.02e0efb0.png";